import gql from 'graphql-tag';

export default gql`
  query inventoryContent(
    $state: String
    $month: String
    $selectedOrderType: String
    $selectedOrderDate: String
  ) {
    inventoryContent(
      state: $state
      month: $month
      selectedOrderType: $selectedOrderType
      selectedOrderDate: $selectedOrderDate
    ) {
      Code
      Vintage
      Uom
      DamNotes
      MVendor
      Closure
      Type
      Varietal
      Org
      Bio
      Focus
      Country
      Region
      App
      RstOff
      RstOffNotes
      RstPrem
      RstAllo
      RstApp
      RstMax
      RstState
      RstSam
      RstBo
      RstMo
      Core
      FocusBm
      Upc
      ScoreWA
      ScoreWS
      ScoreVM
      ScoreOther
      QtyA
      QtyOh
      OnSo
      OnMo
      OnBo
      Level
      Price {
        value
        rawValue
        pricingTiers {
          tier
          price
        }
        product {
          Uom
          Code
          Brand
          Desc
          Vintage
        }
        mixedSizeItems {
          Code
          Brand
          Desc
          Vintage
        }
      }
      Regen
      Abv
      Nat
      Veg
      Hve
      Rcpt
      PriceC
      PriceB
      Description
      DiscountB
      DiscountC
      Discounts
      OnPo
      OnPoSort
      PoDate
      EtaDate
      Restrictions
      Scores
      Red
      HasScore
      maxItemQty {
        byOrderType {
          id
          Qty
          Cases
          Bottles
        }
        PreviousAdd {
          Qty
          Cases
          Bottles
        }
      }
      AvailCmt
      Size
      linkedPrices {
        Code
        Level
        Date
        Price
        Red
      }
    }
  }
`;
